import {
  EMobilityChargingCardsDataModel,
  EMobilityChargingCardsModel,
  EMobilityChargingCardsResponse,
  EMobilityVehiclesModel,
  EMobilityVehiclesResponse,
} from '../models/e-mobility-charging-cards-models'
import { format } from '@e3dc-react/shell/Libs/date'
import { TFunction } from 'i18next'

export const chargingCardsDtoToModel = (
  cardsResponse: EMobilityChargingCardsResponse | undefined,
  vehiclesResponse: EMobilityVehiclesResponse | undefined,
  t: TFunction
): EMobilityChargingCardsDataModel[] => {
  const cards: EMobilityChargingCardsModel[] = cardsResponse
    ? cardsResponse.id.map((id, index) => {
        return {
          id: id,
          serialNo: cardsResponse.serialno[index],
          cardId: cardsResponse.cardId[index] || '',
          rfid: cardsResponse.rfid[index],
          name: cardsResponse.name[index] || '',
          description: cardsResponse.description[index] || '',
          status: cardsResponse.status[index],
          createdAt: format(new Date(cardsResponse.createdAt[index]), t('common.format.date-fns-date')),
          updatedAt: format(new Date(cardsResponse.updatedAt[index]), t('common.format.date-fns-date')),
        }
      })
    : []

  const vehicles: EMobilityVehiclesModel[] = vehiclesResponse
    ? vehiclesResponse.id.map((id, index) => {
        return {
          id: id,
          cardId: vehiclesResponse.cardId[index] || '',
          rfid: vehiclesResponse.rfid[index],
          serialNo: vehiclesResponse.serialno[index],
          vehicleName: vehiclesResponse.name[index],
          color: vehiclesResponse.color[index],
          horsePower: vehiclesResponse.horsepower[index] || '',
          licensePlate: vehiclesResponse.licensePlate[index] || '',
          vehicleDescription: vehiclesResponse.description[index] || '',
          avgConsumption: vehiclesResponse.avgConsumption[index],
          batteryCapacity: vehiclesResponse.batteryCapacity[index],
          vehicleCreatedAt: format(new Date(vehiclesResponse.createdAt[index]), t('common.format.date-fns-date')),
          vehicleUpdatedAt: format(new Date(vehiclesResponse.updatedAt[index]), t('common.format.date-fns-date')),
        }
      })
    : []

  const data: EMobilityChargingCardsDataModel[] = cards.map(card => {
    const cardVehicle = vehicles.find(vehicle => card.rfid === vehicle.rfid)

    return {
      cardId: card.id || 0,
      storageId: card.serialNo,
      vehicleId: cardVehicle?.id || 0,
      rfid: card.rfid,
      name: card.name,
      vehicleName: cardVehicle?.vehicleName || '',
      description: card.description,
      vehicleDescription: cardVehicle?.vehicleDescription || '',
      licensePlate: cardVehicle?.licensePlate || '',
      avgConsumption: cardVehicle?.avgConsumption || null,
      batteryCapacity: cardVehicle?.batteryCapacity || null,
      horsePower: cardVehicle?.horsePower || null,
      status: card.status,
      color: cardVehicle?.color || '',
      createdAt: card.createdAt,
      updatedAt: card.updatedAt,
    }
  })

  return data
}
